"use strict";
/**
 * NOTE: This component will inject the Google Maps API if not already loaded.
 * `<script type="text/javascript" src="https://maps.google.com/maps/api/js?v=VERSION&key=API_KEY&libraries=places"></script>`
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Geocoder = void 0;
var use_places_autocomplete_1 = require("use-places-autocomplete");
var utility_1 = require("../utility");
var Geocoder = /** @class */ (function () {
    function Geocoder(options) {
        var _this = this;
        this.options = options;
        this.addressToLatLng = function (address) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Geocoder.InjectGoogleMapsWithGeocoder(this.options.googleMapsApiVersion, this.options.googleMapsApiKey)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                var geocoder = new google.maps.Geocoder();
                                var response = geocoder.geocode({ address: address }, function (results) {
                                    if (!results || results.length === 0) {
                                        return reject(new Error("Unable to find address."));
                                    }
                                    return resolve(results[0]);
                                });
                            })];
                    case 2:
                        result = _a.sent();
                        if (!result || !result.geometry || !result.geometry.location) {
                            throw new Error("Unable to Geolocate.");
                        }
                        return [2 /*return*/, {
                                lat: result.geometry.location.lat(),
                                lng: result.geometry.location.lng(),
                            }];
                }
            });
        }); };
        this.latLngToAddress = function (position) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Geocoder.InjectGoogleMapsWithGeocoder(this.options.googleMapsApiVersion, this.options.googleMapsApiKey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var geocoder = new google.maps.Geocoder();
                                var response = geocoder.geocode({ location: position }, function (results) {
                                    if (!results || results.length === 0) {
                                        return reject(new Error("Unable to find address."));
                                    }
                                    return resolve(results[0]);
                                });
                            })];
                }
            });
        }); };
        this.browserToLatLng = function (options) {
            if (options === void 0) { options = { maximumAge: 10000, timeout: 5000, enableHighAccuracy: true }; }
            return new Promise(function (resolve, reject) {
                var handlerSuccess = function (location) { return resolve({
                    lat: location.coords.latitude,
                    lng: location.coords.longitude,
                }); };
                var handlerError = function (error) { return reject(error); };
                navigator.geolocation.getCurrentPosition(handlerSuccess, handlerError, options);
            });
        };
        this.placeToGeometry = function (placeId) { return __awaiter(_this, void 0, void 0, function () {
            var place;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, use_places_autocomplete_1.getDetails({
                            placeId: placeId,
                        })];
                    case 1:
                        place = _a.sent();
                        return [2 /*return*/, {
                                location: {
                                    lat: place.geometry.location.lat(),
                                    lng: place.geometry.location.lng(),
                                },
                                viewport: utility_1.Bounds.simplifyBounds(place.geometry.viewport),
                            }];
                }
            });
        }); };
    }
    Geocoder.InjectGoogleMapsWithGeocoder = function (googleMapsApiVersion, googleMapsApiKey) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!window.hasOwnProperty("google") || !window.google.hasOwnProperty("maps") || !window.google.maps.hasOwnProperty("Geocoder"))) return [3 /*break*/, 2];
                    if (!googleMapsApiVersion || !googleMapsApiKey) {
                        throw new Error("Google Maps API has not been pre-loaded and no Version or API Key has been provided.");
                    }
                    return [4 /*yield*/, utility_1.InjectScript("https://maps.google.com/maps/api/js?v=" + googleMapsApiVersion + "&key=" + googleMapsApiKey + "&libraries=places")];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    Geocoder.latLngToDirections = function (destination, origin) {
        if (origin === void 0) { origin = "My+Location"; }
        return "https://www.google.com/maps/dir/" + origin + "/" + destination.lat + "," + destination.lng;
    };
    return Geocoder;
}());
exports.Geocoder = Geocoder;
//# sourceMappingURL=geocoder.js.map